import z from "zod";
import { LABEL_DESCRIPTION_MAX, labelDescriptionSchema, PreAnnotateModelTypeEnum, } from "../preAnnotateSettings/preAnnotateSettings.schema";
export const predictedRectangleSchema = z.object({
    labelId: z.number().int().positive(),
    score: z.number().min(0).max(1),
    x: z.number(),
    y: z.number(),
    width: z.number(),
    height: z.number(),
});
export const VISION_FEEDBACK_MAX = 2000;
export const visionNoteTextSchema = z.string().trim().min(1).max(VISION_FEEDBACK_MAX);
export const runVisionRequestSchema = z.object({
    modelType: z.enum(PreAnnotateModelTypeEnum),
    batchId: z.number().int().positive().optional(),
});
export const visionFeedbackRequestSchema = z.object({
    feedback: visionNoteTextSchema,
});
export const visionTurnUsageSchema = z.object({
    promptTokens: z.number().int().min(0),
    thoughtTokens: z.number().int().min(0),
    outputTokens: z.number().int().min(0),
});
export const visionTurnRecordSchema = z.object({
    index: z.number().int().positive(),
    feedback: z.string().nullable(),
    boxCount: z.number().int().min(0),
    droppedCount: z.number().int().min(0),
    summary: z.string(),
    usage: visionTurnUsageSchema,
    effort: z.string().optional(),
    noteSuggested: z.boolean().optional(),
    noteText: z.string().optional(),
    latencyMs: z.number().int().min(0),
    at: z.string(),
});
export const visionRunResponseSchema = z.object({
    conversationId: z.number().int().positive(),
    turn: z.number().int().positive(),
    modelType: z.literal(PreAnnotateModelTypeEnum.DETECTION),
    rectangles: predictedRectangleSchema.array(),
    summary: z.string(),
    usage: visionTurnUsageSchema,
    noteId: z.number().int().positive().nullable(),
    noteText: z.string().nullable(),
});
export const visionTranscriptTurnSchema = visionTurnRecordSchema.extend({
    note: z
        .object({
        id: z.number().int().positive(),
        userId: z.number().int().positive().nullable(),
    })
        .nullable(),
});
export const visionTranscriptResponseSchema = z.object({
    conversationId: z.number().int().positive(),
    modelType: z.enum(PreAnnotateModelTypeEnum),
    turns: visionTranscriptTurnSchema.array(),
});
export const visionConversationSummarySchema = z.object({
    id: z.number().int().positive(),
    turn: z.number().int().positive(),
});
export var VisionConversationStatusEnum;
(function (VisionConversationStatusEnum) {
    VisionConversationStatusEnum["ACTIVE"] = "active";
    VisionConversationStatusEnum["CLOSED"] = "closed";
})(VisionConversationStatusEnum || (VisionConversationStatusEnum = {}));
export var VisionLlmProviderEnum;
(function (VisionLlmProviderEnum) {
    VisionLlmProviderEnum["GEMINI"] = "gemini";
    VisionLlmProviderEnum["OPENAI"] = "openai";
})(VisionLlmProviderEnum || (VisionLlmProviderEnum = {}));
export const VISION_OPENAI_REASONING_EFFORTS = [
    "low",
    "medium",
    "high",
    "xhigh",
    "max",
];
export const VISION_GEMINI_THINKING_LEVELS = ["low", "medium", "high"];
export const VISION_GEMINI_MODELS = ["gemini-3.8-flash", "gemini-4-argon"];
export const VISION_GEMINI_MODEL_LABELS = {
    "gemini-3.8-flash": "Gemini 3.8 Flash",
    "gemini-4-argon": "Gemini 4 Argon",
};
export const VISION_DEPLOYMENT_DEFAULT = "deployment";
export const VISION_NOTES_WARN_COUNT = 30;
export const VISION_NOTES_WARN_CHARS = 6000;
export const visionProjectNoteSchema = z.object({
    id: z.number().int().positive(),
    text: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
    author: z
        .object({
        id: z.number().int().positive(),
        fullName: z.string(),
    })
        .nullable(),
    taskId: z.number().int().positive().nullable(),
    conversationId: z.number().int().positive().nullable(),
    turnIndex: z.number().int().positive().nullable(),
});
export const visionNoteCreateRequestSchema = z.object({
    text: visionNoteTextSchema,
});
export const visionNoteUpdateRequestSchema = z.object({
    text: visionNoteTextSchema,
});
export const visionProjectNotesResponseSchema = z.object({
    notes: visionProjectNoteSchema.array(),
});
export var VisionStreamPhaseEnum;
(function (VisionStreamPhaseEnum) {
    VisionStreamPhaseEnum["IMAGE"] = "image";
    VisionStreamPhaseEnum["THINKING"] = "thinking";
    VisionStreamPhaseEnum["BOXES"] = "boxes";
})(VisionStreamPhaseEnum || (VisionStreamPhaseEnum = {}));
export const visionStreamEventSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("phase"),
        phase: z.enum(VisionStreamPhaseEnum),
    }),
    z.object({
        type: z.literal("thought"),
        text: z.string(),
    }),
    z.object({
        type: z.literal("box"),
        rectangle: predictedRectangleSchema,
    }),
    z.object({
        type: z.literal("done"),
        result: visionRunResponseSchema,
    }),
    z.object({
        type: z.literal("error"),
        status: z.number().int(),
        code: z.string(),
        message: z.string(),
        params: z.record(z.string(), z.unknown()).optional(),
    }),
]);
export const labelDescriptionRegionSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("bbox"),
        x: z.number(),
        y: z.number(),
        width: z.number().positive(),
        height: z.number().positive(),
    }),
    z.object({
        type: z.literal("polygon"),
        points: z.tuple([z.number(), z.number()]).array().min(3),
    }),
]);
export const suggestLabelDescriptionRequestSchema = z.object({
    labelId: z.number().int().positive().optional(),
    name: z.string().trim().min(1).max(256),
    currentDescription: labelDescriptionSchema.optional(),
    taskId: z.number().int().positive().optional(),
    region: labelDescriptionRegionSchema.optional(),
});
export const suggestLabelDescriptionResponseSchema = z.object({
    description: z.string().max(LABEL_DESCRIPTION_MAX),
});
//# sourceMappingURL=vision.schema.js.map